var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgXlsxIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6531_45097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0145 1.05566H4.72367C4.54832 1.05566 4.38014 1.12532 4.25615 1.24932C4.13216 1.37331 4.0625 1.54148 4.0625 1.71683V4.52766L10.0145 7.99966L12.9905 9.25554L15.9665 7.99966V4.52766L10.0145 1.05566Z",
    fill: "#21A366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.0625 4.53223H10.0145V8.00423H4.0625V4.53223Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3065 1.05566H10.0156V4.52766H15.9676V1.71683C15.9676 1.54148 15.898 1.37331 15.774 1.24932C15.65 1.12532 15.4818 1.05566 15.3065 1.05566Z",
    fill: "#33C481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0145 8.00879H4.0625V14.2916C4.0625 14.467 4.13216 14.6351 4.25615 14.7591C4.38014 14.8831 4.54832 14.9528 4.72367 14.9528H15.3053C15.4807 14.9528 15.6489 14.8831 15.7728 14.7591C15.8968 14.6351 15.9665 14.467 15.9665 14.2916V11.4808L10.0145 8.00879Z",
    fill: "#185C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0156 8.00879H15.9676V11.4808H10.0156V8.00879Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8.36133 3.54004H4.0625V12.964H8.36133C8.53652 12.9635 8.70439 12.8937 8.82827 12.7698C8.95215 12.6459 9.02198 12.4781 9.0225 12.3029V4.20121C9.02198 4.02602 8.95215 3.85815 8.82827 3.73427C8.70439 3.61039 8.53652 3.54056 8.36133 3.54004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.86533 4.04004H4.0625V13.464H7.86533C8.04052 13.4635 8.20839 13.3937 8.33227 13.2698C8.45615 13.1459 8.52598 12.9781 8.5265 12.8029V4.70121C8.52598 4.52602 8.45615 4.35815 8.33227 4.23427C8.20839 4.11039 8.04052 4.04056 7.86533 4.04004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.86533 4.04004H4.0625V12.472H7.86533C8.04052 12.4715 8.20839 12.4017 8.33227 12.2778C8.45615 12.1539 8.52598 11.9861 8.5265 11.8109V4.70121C8.52598 4.52602 8.45615 4.35815 8.33227 4.23427C8.20839 4.11039 8.04052 4.04056 7.86533 4.04004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.36933 4.04004H4.0625V12.472H7.36933C7.54452 12.4715 7.71239 12.4017 7.83627 12.2778C7.96015 12.1539 8.02998 11.9861 8.0305 11.8109V4.70121C8.02998 4.52602 7.96015 4.35815 7.83627 4.23427C7.71239 4.11039 7.54452 4.04056 7.36933 4.04004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.754918 4.04004H7.36858C7.54393 4.04004 7.71211 4.1097 7.8361 4.23369C7.96009 4.35768 8.02975 4.52585 8.02975 4.70121V11.3149C8.02975 11.4902 7.96009 11.6584 7.8361 11.7824C7.71211 11.9064 7.54393 11.976 7.36858 11.976H0.754918C0.579565 11.976 0.411395 11.9064 0.287402 11.7824C0.163409 11.6584 0.09375 11.4902 0.09375 11.3149L0.09375 4.70121C0.09375 4.52585 0.163409 4.35768 0.287402 4.23369C0.411395 4.1097 0.579565 4.04004 0.754918 4.04004Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.84766 10.4844L3.45271 7.99747L1.98257 5.52441H3.16553L3.96806 7.10517C4.0418 7.25496 4.09255 7.36672 4.12033 7.44046H4.13074C4.18365 7.32076 4.23904 7.20437 4.2969 7.09128L5.15449 5.52441H6.24023L4.73239 7.98358L6.27842 10.4844H5.12274L4.19572 8.74841C4.15205 8.67447 4.11503 8.59679 4.08511 8.51629H4.07122C4.04417 8.59501 4.00823 8.6704 3.96409 8.74097L3.01028 10.4844H1.84766Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6531_45097"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15.872,
    fill: "white",
    transform: "translate(0 0.0644531)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgXlsxIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/xlsx_icon.e625ef91.svg";
export { ForwardRef as ReactComponent };